import { Box, BoxProps, Stack } from "@mui/material";
import { IWikifolioDetailData, IWikifolioDetailDict } from "src/api/server/wf-detail.types";
import { ITag as ILegacyTag } from "src/components/common/tag/tag.types";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { PopoverButtonIconInfo } from "src/components-mui/base/wf-popover/popover-button-icon-info";
import { WfPopover } from "src/components-mui/base/wf-popover/wf-popover";
import { Tag } from "src/components-mui/common/tag/tag";
import { EnumTagColor } from "src/types/common-enum";

const TAG_SECTION_TEST_ID = "tag-section";

type TTagData = NonNullable<IWikifolioDetailData["tagsData"]>;

interface IProps extends BoxProps {
    dict: NonNullable<IWikifolioDetailDict["tagSection"]>;
    data: TTagData;
}

interface ITagGroupProps {
    tags: ILegacyTag[];
    color: EnumTagColor;
    keyPrefix: string;
}

const TagGroup = ({ tags, color, keyPrefix }: ITagGroupProps) => (
    <>
        {tags.map((tag, index) => (
            <Tag
                key={keyPrefix + index}
                label={tag.label}
                color={color}
                isCrossedOut={tag.isCrossedOut}
                sx={{ lineHeight: 1.2 }}
                tooltip={typeof tag.tooltip === "string" ? tag.tooltipRaw : tag.tooltip}
                popoverSlotProps={{ popper: { zIndex: 1 } }}
            />
        ))}
    </>
);

export const TagSection = ({ dict, data, ...boxProps }: IProps) => {
    return (
        <Box component="section" {...boxProps} data-test-id={TAG_SECTION_TEST_ID}>
            <Stack direction="row" sx={{ alignItems: "center", mb: 3 }}>
                <WfHeading component="h2" fontSize="2xl">
                    {dict.title}
                </WfHeading>
                <WfPopover
                    PopoverTrigger={<PopoverButtonIconInfo ariaLabel={dict.title} sx={{ ml: 1 }} />}
                    {...dict.tooltip}
                    slotProps={{ popper: { zIndex: 1 } }}
                />
            </Stack>
            <Stack direction="row" sx={{ flexWrap: "wrap", gap: 2 }}>
                <TagGroup tags={data.rewards} color={EnumTagColor.Green} keyPrefix="r" />
                <TagGroup tags={data.tradings} color={EnumTagColor.Lilac} keyPrefix="t" />
                <TagGroup tags={data.investmentHorizon} color={EnumTagColor.Blue} keyPrefix="ih" />
                <TagGroup tags={data.investmentRegion} color={EnumTagColor.Orange} keyPrefix="ir" />
                <TagGroup tags={data.basics} color={EnumTagColor.Gray} keyPrefix="b" />
                <TagGroup tags={data.bvhChallenge} color={EnumTagColor.Blush} keyPrefix="bch" />
                <TagGroup tags={data.alphaBeta} color={EnumTagColor.Teal} keyPrefix="ab" />
            </Stack>
        </Box>
    );
};
